<script setup lang="ts">
import AttentionIcon from '@/assets/Icons/AttentionIcon.svg'
import AttentionNoFillIcon from '@/assets/Icons/AttentionNoFillIcon.svg'
import CheckmarkGreenIcon from '@/assets/Icons/CheckmarkGreenIcon.svg'

defineProps<{
  twoState?: boolean
  state?: boolean
}>()
</script>

<template>
  <div class="form-error" :class="{ twoState: twoState, correct: state }">
    <AttentionNoFillIcon v-if="!twoState" />
    <AttentionNoFillIcon v-else-if="!state" />
    <CheckmarkGreenIcon v-else />
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
.form-error {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--ullib-color-red);
  font-weight: 500;

  &.twoState {
    font-weight: 400;
    color: var(--ullib-color-font);
  }
}
</style>
